import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import * as Views from './views'
import Layout from './Layout'
import { PATH, makePath } from 'config'

const propTypes = {}

function Routes() {
  const { path } = useRouteMatch()

  return (
    <Layout>
      <Switch>
        <Route path={makePath(path, PATH.EXISTING_MEMBER)}>
          <Views.ExistingMemberRegistration />
        </Route>
        <Route path={makePath(path, PATH.NEW_MEMBER)}>
          <Views.NewMemberRegistration />
        </Route>
        <Route path={makePath(path, PATH.ERROR)}>
          <Views.RegistrationError />
        </Route>
      </Switch>
    </Layout>
  )
}

Routes.propTypes = propTypes

export default Routes
